




















import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import SimpleInput from '@/UI/Shared/SimpleInput.vue'
import SearchButton from '@/UI/Shared/SearchButton.vue'
import Message from '@/UI/Shared/Message.vue'
import { FetchResforByNifCommandHandlerProvider } from '@/Infrastructure/Resfor/Provider'
import { FetchResforByNifCommand, ResforDataDto } from '@/Application/Resfor'
import { ResforRepositoryError, ResforNotFoundError, ResforNifNotFoundError, ResforCommunicationYearNotValidError } from '@/Domain/Resfor'
import { PersonalData } from '@/Infrastructure/Store/Auction/PersonalData'

const auctionStore = namespace('auction')

@Component({
  components: { SimpleInput, SearchButton, Message }
})
export default class ResforForm extends Vue {
  loading = false
  errorMessage = ''
  inputStatus = ''
  currentResforNif = ''

  @auctionStore.Getter
  public resforCode!: string

  @auctionStore.Getter
  public resforNif!: string

  @auctionStore.Getter
  public personalData!: PersonalData

  @auctionStore.Action
  public setResforNif!: (resforNif: string) => void

  @auctionStore.Action
  public setResforCode!: (resforCode: string) => void

  @auctionStore.Action
  public updatePersonalDataWithResforData!: (payload: ResforDataDto) => void

  onSearchButtonClicked (): void {
    this.loadResforData(this.currentResforNif)
  }

  mounted (): void {
    this.currentResforNif = this.resforNif
    if (this.currentResforNif !== '') {
      this.$emit('resfor-loaded')
    }
  }

  onResforFailed (message: string): void {
    this.inputStatus = 'danger'
    this.errorMessage = message
    this.$emit('resfor-error')
  }

  loadResforData (resforNif: string): void {
    this.errorMessage = ''
    this.inputStatus = ''
    const provider = new FetchResforByNifCommandHandlerProvider()
    const handler = provider.provide()
    const command = new FetchResforByNifCommand(resforNif)
    this.loading = true
    handler.handle(command)
      .then((response: ResforDataDto) => {
        this.setResforNif(this.currentResforNif)
        this.setResforCode(response.resforCode)
        this.inputStatus = 'success'
        this.updatePersonalDataWithResforData(response)
        this.$emit('resfor-loaded')
      })
      .catch(error => {
        if (error instanceof ResforRepositoryError) {
          this.onResforFailed(this.$t('subasta.persoais.resfor-repository-error').toString())
          return
        }
        if (error instanceof ResforNotFoundError) {
          this.onResforFailed(this.$t('subasta.persoais.resfor-no-encontrado').toString())
          return
        }
        if (error instanceof ResforNifNotFoundError) {
          this.onResforFailed(this.$t('subasta.persoais.nif-no-existe').toString())
          return
        }
        if (error instanceof ResforCommunicationYearNotValidError) {
          this.onResforFailed(this.$t('subasta.persoais.resfor-communication-year-error').toString())
          return
        }
        if (error instanceof TypeError) {
          this.onResforFailed(this.$t('subasta.persoais.resfor-wrong-format').toString())
          return
        }
        this.onResforFailed(this.$t('subasta.persoais.resfor-error').toString())
      })
      .finally(() => {
        this.loading = false
      })
  }
}
